import { render, staticRenderFns } from "./areaRptIndexParent.vue?vue&type=template&id=0b6db5b8&scoped=true&"
import script from "./areaRptIndexParent.vue?vue&type=script&lang=js&"
export * from "./areaRptIndexParent.vue?vue&type=script&lang=js&"
import style0 from "./areaRptIndexParent.vue?vue&type=style&index=0&id=0b6db5b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6db5b8",
  null
  
)

export default component.exports